import React from "react";

const HomologacionInterna = () => {
  return (
    <div className="card-container">
      <header className="card-header">
        <h2>Homologación interna</h2>
        <p className="subtitle">
          <strong> Convalida sin costo </strong> las materias que ya aprobaste
          en la UTPL sea de grado, posgrado o tecnología y{" "}
          <strong> cámbiate a otra carrera o programa</strong> en la
          institución, avanzando más rápido hacia tu título profesional.
        </p>
      </header>

      <section className="card-body">
        <div className="alert-box special-note margin">
          <h4>Importante:</h4>
          <p>
            El cambio de programa puede realizar para grado, posgrado o
            tecnología.{" "}
          </p>
          <p>
            Recuerda que puedes realizar el cambio de carrera o programa con
            estudios vigentes o cursados hasta hace 10 años en la UTPL.
          </p>

          <p>
            En caso de solicitar un cambio de programa en una carrera de
            modalidad presencial o un programa de posgrado, debes cumplir con el
            proceso de admisión correspondiente en la carrera o programa de
            destino.
          </p>
        </div>
        <div className="button-group">
        
          <button
            className="btn-primary"
            onClick={() =>
              (window.location.href =
                "https://studentssb-prod.srv.utpl.edu.ec/StudentSelfService")
            }
          >
           Solicitar cambio de carrera o programa 
          </button>
        </div>
        <div className="process-section">
          <h3>Proceso de solicitud:</h3>
   
              <ul className="sub-step-list">
                <li>
                  Haz clic en <strong>Solicitar cambio de carrera o programa </strong> e ingresa
                  con tus credenciales institucionales.
                </li>
                <li>
                  Dirígete a <strong>Solicitud de Servicios</strong>, selecciona{" "}
                  <strong>Servicios-Reconocimiento de estudios</strong> y elige
                  la opción:{" "}
                  <strong>
                  Solicitar cambio de carrera / programa (Reconocimiento interno) 
                  </strong>
                  .
                </li>
                <li>
                  Selecciona tu carrera/programa actual y en detalle de requerimiento escribe{" "}
                  <em>Solicito cambio de programa a la carrera de…</em>
                </li>
           
              </ul>
          
        </div>

        <div className="info-grid dual-info">
          <div className="info-item">
            <span className="label">Costo del servicio:</span>
            <span className="value">Gratuito</span>
          </div>
        </div>

        <p className="status-note additional-info">
          Consulta el estado de la solicitud en el sistema institucional,
          apartado <strong>Ver status de la solicitud de servicio</strong>.
        </p>
        <p className="status-note additional-info">
          Recibirás un informe de las materias homologadas y luego podrás
          matricularte en las asignaturas correspondientes.
        </p>
      </section>

      <footer className="card-footer">
        <h4>¿Necesitas más información?</h4>
        <p>Solicita asesoría virtual en:</p>
        <div className="contact-links">
          <a href="https://utpl.edu.ec/zoom" target="_blank" rel="noreferrer">
            utpl.edu.ec/zoom
          </a>
          <a href="https://wa.me/593999565400" target="_blank" rel="noreferrer">
            WhatsApp: 0999565400
          </a>
        </div>
      </footer>
    </div>
  );
};

export default HomologacionInterna;
